'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.forEach = forEach;
exports.extend = extend;
exports.getElementByHashLink = getElementByHashLink;
exports.isDescendant = isDescendant;
exports.sanitizeElementData = sanitizeElementData;
exports.createCookie = createCookie;
exports.readCookie = readCookie;
exports.eraseCookie = eraseCookie;
exports.createElementFromHtml = createElementFromHtml;
function forEach(array, callback, scope) {
	for (var i = 0; i < array.length; i++) {
		callback.call(scope, array[i], i); // passes back stuff we need
	}
}

function extend(obj, src) {
	for (var key in src) {
		if (src.hasOwnProperty(key)) obj[key] = src[key];
	}
	return obj;
}

function getElementByHashLink(link) {
	var contentId = link.hash.substr(1);
	return document.getElementById(contentId);
}

function isDescendant(child, parent) {
	var node = child.parentNode;
	while (node != null) {
		if (node == parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}

function sanitizeElementData(element) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var allowedKeys = options.allowedKeys,
	    sanitizeKeyFunc = options.sanitizeKeyFunc,
	    sanitizeValueFunc = options.sanitizeValueFunc;


	var sanitizedDataset = {};
	var value = void 0;
	var sanitizedKey = void 0;
	var sanitizedValue = void 0;

	Object.keys(element.dataset).map(function (key) {

		if (sanitizeKeyFunc) sanitizedKey = sanitizeKeyFunc(key);

		value = element.dataset[key];

		if (value === 'true') {
			sanitizedValue = true;
		} else if (value === 'false') {
			sanitizedValue = false;
		} else {
			sanitizedValue = value;
		}

		if (sanitizeValueFunc) sanitizedValue = sanitizeValueFunc(sanitizedValue);

		if (!allowedKeys || allowedKeys && allowedKeys.includes(sanitizedKey)) {
			sanitizedDataset[sanitizedKey] = sanitizedValue;
		}
	});

	return sanitizedDataset;
}

function createCookie(name, value, days) {
	var date = void 0,
	    expires = void 0;

	if (days) {
		date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toGMTString();
	} else {
		expires = "";
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
	var i,
	    c,
	    nameEQ = name + "=",
	    ca = document.cookie.split(';');

	for (i = 0; i < ca.length; i++) {
		c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}

function createElementFromHtml(html) {
	var containerElem = document.createElement('div');
	containerElem.innerHTML = html;
	return containerElem.firstChild;
}

function whichTransitionEvent() {
	var t = void 0,
	    el = document.createElement("fakeelement");

	var transitions = {
		"transition": "transitionend",
		"OTransition": "oTransitionEnd",
		"MozTransition": "transitionend",
		"WebkitTransition": "webkitTransitionEnd"
	};

	for (t in transitions) {
		if (el.style[t] !== undefined) {
			return transitions[t];
		}
	}

	return false;
}

var transitionEvent = exports.transitionEvent = whichTransitionEvent();

function whichAnimationEvent() {
	var t,
	    el = document.createElement("fakeelement");

	var animations = {
		"animation": "animationend",
		"OAnimation": "oAnimationEnd",
		"MozAnimation": "animationend",
		"WebkitAnimation": "webkitAnimationEnd"
	};

	for (t in animations) {
		if (el.style[t] !== undefined) {
			return animations[t];
		}
	}
}

var animationEvent = exports.animationEvent = whichAnimationEvent();
//# sourceMappingURL=utilities.js.map
